import { gettext } from '@eventbrite/i18n';

export const TICKET_STATUS_SOLD_OUT = 'SOLD_OUT';
export const TICKET_STATUS_AVAILABLE = 'AVAILABLE';
export const TICKET_STATUS_UNAVAILABLE = 'UNAVAILABLE';

export const EMPTY_PRICE_RANGE = '—';
export const FREE_TICKET_LABEL = gettext('Free');
